import {Injectable} from '@angular/core';
import {Solution} from 'src/app/models/service/solution';
import {SolutionVersionsInfo} from 'src/app/models/service/solution-versions-info';
import {Instance} from 'src/app/models/instance/instance';
import {SolutionVersion} from 'src/app/models/service/solution-version';
import {SemanticVersioningService} from 'src/app/services/util/semantic-versioning.service';
import {SolutionStatus} from 'src/app/models/service/solution-status';
import {DataZone} from '../../models/data-zone/data-zone';
import {DeployStatus} from '../../models/deploy/deploy-status';
import {DeploymentClass} from '../../models/instance-class';
import {FabricService} from 'src/app/services/fabric/fabric.service';
import {Observable} from 'rxjs';

const SERVICE_NAME = 'mgmt-solution-resources';

@Injectable({
  providedIn: 'root'
})
export class SolutionVersionsService {
  instanceSolutionVersion: any;
  currentSolutionVersion: any;
  readonly INSTANCE_FILTERED_STATES = [DeployStatus.INITIALIZED, DeployStatus.INITIALIZE_FAILED, DeployStatus.INITIALIZING, DeployStatus.DEPLOYED, DeployStatus.FAILED, DeployStatus.DEPLOYING,
    DeployStatus.CONFIGURING, DeployStatus.CONFIGURATION_FAILED, DeployStatus.CONFIGURED, DeployStatus.TESTED, DeployStatus.UPDATED,
    DeployStatus.UPDATE_FAILED, DeployStatus.TEST_FAILED, DeployStatus.FAILOVER_APPLYING, DeployStatus.FAILBACK_APPLYING,
    DeployStatus.PRE_FAILBACK_APPLYING, DeployStatus.FAILOVER_FAILED, DeployStatus.FAILBACK_FAILED, DeployStatus.PRE_FAILBACK_FAILED, DeployStatus.POST_FAILBACK_APPLYING, DeployStatus.POST_FAILBACK_FAILED];

  constructor(private semanticVersioningService: SemanticVersioningService, private fabricService: FabricService) {

  }

  /**
   * Calcualtes service versions information holding information for current service version,
   * latest published version and latest coming soon version.
   *
   * @param service for which we want to get the versions info
   * @param serviceVersions all service versions
   * @param instances all instances for a given blueprint.
   */
  getSolutionVersionsInfo(service: Solution, serviceVersions: SolutionVersion[], instances: Instance[]): SolutionVersionsInfo {
    if(instances?.length > 0) {
      const filteredInstances = instances.filter(item => this.INSTANCE_FILTERED_STATES.includes(item.status));
    this.instanceSolutionVersion;
    this.instanceSolutionVersion = (filteredInstances?.find(instances => instances.deploymentClass === DeploymentClass.A)) ? (filteredInstances?.find(instances => instances.deploymentClass === DeploymentClass.A).solutionVersionId)
    : (filteredInstances?.find(instances => instances.deploymentClass === DeploymentClass.B)) ? (filteredInstances.filter(i => i.deploymentClass === DeploymentClass.B)[filteredInstances.filter(i => i.deploymentClass === DeploymentClass.B).length -1].solutionVersionId)
    : (filteredInstances?.find(instances => instances.deploymentClass === DeploymentClass.C)) ? (filteredInstances.filter(i => i.deploymentClass === DeploymentClass.C)[filteredInstances.filter(i => i.deploymentClass === DeploymentClass.C).length -1].solutionVersionId)
    : (filteredInstances?.find(instances => instances.deploymentClass === DeploymentClass.D)) ? (filteredInstances.filter(i => i.deploymentClass === DeploymentClass.D)[filteredInstances.filter(i => i.deploymentClass === DeploymentClass.D).length -1].solutionVersionId)  : service.latestSolutionVersionId;
      }
      this.currentSolutionVersion = (!this.instanceSolutionVersion || this.instanceSolutionVersion === "undefined") ? service.latestSolutionVersionId : this.instanceSolutionVersion;
    const serviceVersionsMap = serviceVersions.reduce((acc, solutionVersion) => {
      acc[solutionVersion.id] = solutionVersion;
      return acc;
    }, {});

    let liveInstance = null;
    let devVersion = null;

    instances.forEach(instance => {
      if (instance.dataZone === DataZone.LIVE && instance.status === DeployStatus.DEPLOYED) {
        liveInstance = instance;
      }
      if (instance.deploymentClass === DeploymentClass.D && instance.status === DeployStatus.DEPLOYED) {
        devVersion = serviceVersionsMap[instance.solutionVersionId];
      }
    });

    let currentVersion: SolutionVersion;
    if (!liveInstance) {
      currentVersion = serviceVersions.find(v => v.id === service.latestSolutionVersionId) || serviceVersions[0];
      return {currentVersion, devVersion, comingSoonVersion: null, updateVersion: null};
    } else {
      currentVersion = serviceVersionsMap[liveInstance.solutionVersionId];
    }

    const updateVersion = serviceVersions.reduce<SolutionVersion>((latestVersion, serviceVersion) => {
      if (serviceVersion.status === SolutionStatus.PUBLISHED
        && currentVersion.id !== serviceVersion.id
        && this.semanticVersioningService.compareVersions(currentVersion.version, serviceVersion.version)
        && (!latestVersion || this.semanticVersioningService.compareVersions(latestVersion.version, serviceVersion.version))) {
        latestVersion = serviceVersion;
      }
      return latestVersion;
    }, undefined);

    const comingSoonVersion = serviceVersions.reduce<SolutionVersion>((latestVersion, serviceVersion) => {
      if (serviceVersion.status === SolutionStatus.COMING_SOON
        && currentVersion.id !== serviceVersion.id
        && this.semanticVersioningService.compareVersions(currentVersion.version, serviceVersion.version)
        && (!latestVersion || this.semanticVersioningService.compareVersions(latestVersion.version, serviceVersion.version))) {
        latestVersion = serviceVersion;
      }
      return latestVersion;
    }, undefined);

    return {currentVersion, updateVersion, comingSoonVersion, devVersion};
  }

  createSolutionVersion(solutionversion: SolutionVersion): Observable<SolutionVersion> {

    return this.fabricService.invokeOperation<any>(SERVICE_NAME, 'post_solutions_solutionid_versions', solutionversion);

  }

  releaseVersion(releaseVersionText): boolean {
    const verifyVersion = releaseVersionText?.split('.');
    if (verifyVersion) {
      releaseVersionText = verifyVersion[0];
      if(releaseVersionText.length === 2 || (releaseVersionText.startsWith('R') && releaseVersionText.length === 3)){
        return true;
      }
    }
  }

}
